import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';

export default function RulesPage() {
  const rules = [
    { title: 'Discipline & Behavior', desc: 'Students must maintain discipline, respect teachers and fellow students. Bullying is strictly prohibited.' },
    { title: 'Attendance & Punctuality', desc: 'Regular attendance is compulsory. Students must reach school on time.' },
    { title: 'Uniform', desc: 'Students must come in proper and complete school uniform with neat appearance.' },
    { title: 'Academic Responsibility', desc: 'Complete homework and assignments regularly. Participation in all activities is mandatory.' },
    { title: 'School Property', desc: 'Take care of school property and maintain cleanliness. Damage will result in disciplinary action.' },
    { title: 'Fees', desc: 'School fees must be paid on time as per schedule.' },
    { title: 'Electronic Gadgets', desc: 'Mobile phones and unauthorized devices are not allowed without permission.' },
    { title: 'Safety Rules', desc: 'Follow safety instructions during school hours, transport, and activities.' }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Rules & Regulations</h1>
          <p className="text-xl text-blue-100">Maintaining discipline and a positive learning environment</p>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {rules.map((rule, i) => (
              <GlassCard key={i}>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-900 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                    {i + 1}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-900 mb-2">{rule.title}</h3>
                    <p className="text-slate-600">{rule.desc}</p>
                  </div>
                </div>
              </GlassCard>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
